import React from 'react';
import { number } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { StarRating } from 'dibs-elements/exports/StarRating';

import styles from './PdpSharedStarRating.scss';

function PdpSharedStarRating({ feedbackRating }) {
    return (
        <div className={styles.container}>
            <StarRating rating={feedbackRating} size="small" />
            <div className={styles.fraction}>
                {feedbackRating ? (
                    <FormattedMessage
                        id="PdpSharedStarRating.feedbackRating"
                        defaultMessage={`{feedbackRating, number} / 5`}
                        values={{ feedbackRating }}
                    />
                ) : (
                    <FormattedMessage
                        id="PdpSharedStarRating.noReviews"
                        defaultMessage="No Reviews Yet"
                    />
                )}
            </div>
        </div>
    );
}

PdpSharedStarRating.propTypes = {
    feedbackRating: number,
};

export { PdpSharedStarRating };
